import React from 'react'
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle
} from '@material-ui/core'

interface ConfirmDeleteModalProps {
	open: boolean
	onClose: () => void
	handleDelete: () => void
	isDeleting?: boolean
}

const SubsectionDelete: React.FC<ConfirmDeleteModalProps> = ({
	open,
	onClose,
	handleDelete,
	isDeleting = false
}) => {
	return (
		<Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
			<DialogTitle>Confirm Delete</DialogTitle>
			<DialogContent>
				<DialogContentText>
					Are you sure you want to delete this item? This action cannot be undone.
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose} variant="outlined" disabled={isDeleting}>
					Cancel
				</Button>
				<Button
					onClick={handleDelete}
					variant="contained"
					sx={{
						backgroundColor: '#B22222',
						'&:hover': {
							backgroundColor: '#cc3d3d'
						}
					}}
				>
					Ok
				</Button>
			</DialogActions>
		</Dialog>
	)
}

export default SubsectionDelete
